import React from 'react';
//animeJs
import anime from 'animejs';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'halfCircleSVG',
}) => {
  const hoverRef = React.createRef();
  const onHoverOn = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('halfCircleSVG_hover');
  };
  const onHoverOut = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('halfCircleSVG_hover');
  };
  return (
    <svg
      viewBox="0 0 288 255.5"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
    >
      <path
        d="M136.8,40.8V221c49.8,0,90.1-40.3,90.1-90.1C226.9,81.1,186.6,40.8,136.8,40.8z"
        ref={hoverRef}
      />
    </svg>
  );
};

export default SVG;
